import script from "./CoordinatesControl.vue?vue&type=script&lang=ts"
export * from "./CoordinatesControl.vue?vue&type=script&lang=ts"
script.__scopeId = "data-v-d2c24c60"

export default script